module.exports = __webpack_public_path__ + "static/media/icon-speaker.f5f3bd4f.svg";